var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightarrW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 66,
    viewBox: "0 0 101 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.8438H76.436",
    stroke: "white",
    strokeMiterlimit: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8198 32.8445C99.8198 50.4305 85.5628 64.6875 67.9758 64.6875C50.3898 64.6875 36.1328 50.4305 36.1328 32.8445C36.1328 15.2575 50.3898 1.0005 67.9758 1.0005C85.5628 1.0005 99.8198 15.2575 99.8198 32.8445Z",
    stroke: "white",
    strokeMiterlimit: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7484 36.9336L72.0664 36.2016L75.6784 32.8446L72.0664 29.4876L72.7484 28.7546L77.1464 32.8446L72.7484 36.9336Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrW);
export default __webpack_public_path__ + "static/media/rightarrW.f127f29d9149f0f3117fc5036e38ab3f.svg";
export { ForwardRef as ReactComponent };